import React, { Component, useState, useEffect } from 'react'
import { translate } from 'react-polyglot'
import Swiper from 'react-id-swiper'

import history from 'configureHistory'
import EE from 'emitter.js'
import { ButtonGroup, Button, Modal } from 'components'

import 'swiper/swiper.scss'
import './onboardingModal.scss'

const OnboardingSlider = ({ name, onClose, t }) => {
	const [swiper, setSwiper] = useState(null)
	const [, setSlideIndex] = useState(0)

	const params = {
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	}

	useEffect(() => {
		if (swiper !== null) {
			swiper.on('slideChange', () => setSlideIndex(swiper.realIndex))
		}

		return () => {
			if (swiper !== null) {
				swiper.off('slideChange', () => setSlideIndex(swiper.realIndex))
			}
		}
	}, [swiper])

	const goNext = () => {
		if (swiper !== null) {
			swiper.slideNext()
		}
	}

	const goPrev = () => {
		if (swiper !== null) {
			swiper.slidePrev()
		}
	}

	const renderPrevButton = () => {
		if (swiper !== null && !swiper.isBeginning) {
			return <Button text={t('back')} onClick={goPrev} size="small" />
		}
	}

	const renderNextButton = () => {
		if (swiper !== null && swiper.isBeginning) {
			return (
				<Button
					text={t('onboarding_start')}
					onClick={goNext}
					layout="secondary"
					size="small"
				/>
			)
		}

		if (swiper !== null && swiper.isEnd) {
			return (
				<Button
					text={t('close')}
					layout="secondary"
					size="small"
					onClick={onClose}
				/>
			)
		}

		if (swiper !== null) {
			return (
				<Button
					text={t('next')}
					onClick={goNext}
					layout="secondary"
					size="small"
				/>
			)
		}
	}

	return (
		<div className="c-onboarding">
			<Swiper getSwiper={setSwiper} {...params}>
				<div>
					<img
						className="c-onboarding__media"
						src="/assets/img/onboarding.svg"
						alt=""
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_intro_title')} {name} 👋🏻
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_intro_text')}
						</div>
					</div>
				</div>
				<div>
					<video
						className="c-onboarding__media"
						src="/assets/video/onboarding/invite.mp4"
						autoPlay
						muted
						loop
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_invite_title')}
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_invite_text')}
						</div>
					</div>
				</div>
				<div>
					<video
						className="c-onboarding__media"
						src="/assets/video/onboarding/edit-profile.mp4"
						autoPlay
						muted
						loop
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_profile_title')}
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_profile_text')}
						</div>
					</div>
				</div>
				<div>
					<video
						className="c-onboarding__media"
						src="/assets/video/onboarding/structure.mp4"
						autoPlay
						muted
						loop
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_entry_title')}
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_entry_text')}
						</div>
					</div>
				</div>
				<div>
					<video
						className="c-onboarding__media"
						src="/assets/video/onboarding/edit-style.mp4"
						autoPlay
						muted
						loop
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_style_title')}
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_style_text')}
						</div>
					</div>
				</div>
				<div>
					<video
						className="c-onboarding__media"
						src="/assets/video/onboarding/customize.mp4"
						autoPlay
						muted
						loop
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_customize_title')}
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_customize_text')}
						</div>
					</div>
				</div>
				<div>
					<img
						className="c-onboarding__media"
						src="/assets/img/onboarding.svg"
						alt=""
					/>
					<div className="c-onboarding__content">
						<div className="c-onboarding__title">
							{t('onboarding_outro_title')}
						</div>
						<div className="c-onboarding__text">
							{t('onboarding_outro_text')}
						</div>
					</div>
				</div>
			</Swiper>
			<div className="c-onboarding__actions">
				<div className="swiper-pagination" />
				<ButtonGroup>
					{renderPrevButton()}
					{renderNextButton()}
				</ButtonGroup>
			</div>
		</div>
	)
}

class Onboarding extends Component {
	constructor(props) {
		super(props)
		this.state = {
			onboardingOpen: false,
		}
	}

	componentDidMount() {
		EE.on('showOnboardingModal', () => {
			this.setState({ onboardingOpen: true })
		})
	}

	componentWillUnmount() {
		EE.off('showOnboardingModal')
	}

	hideOnboarding = () => {
		this.setState({ onboardingOpen: false })

		history.push({ hash: '' })
	}

	render() {
		const { name, t } = this.props
		const { onboardingOpen } = this.state

		return (
			<>
				{onboardingOpen && (
					<Modal
						visible={onboardingOpen}
						onClose={this.hideOnboarding}
					>
						<OnboardingSlider
							name={name}
							onClose={this.hideOnboarding}
							t={t}
						/>
					</Modal>
				)}
			</>
		)
	}
}
export default translate()(Onboarding)
